<template>
  <div class="language-selector" @click="toggle">
    <ul :class="{ expanded }">
      <li class="current">{{ $store.getters['Langs/key'] }}</li>
      <li v-for="item in $store.getters['Langs/keys']" :key="item" class="item" @click.stop="selectLanguage(item)" :class="{ selected: item === $store.getters['Langs/key']}">{{item}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'language-selector',
  methods: {
    toggle () {
      this.expanded = !this.expanded
    },
    selectLanguage (language) {
      this.$store.dispatch('Langs/setKey', language)
      this.expanded = false
    }
  },
  data () {
    return {
      expanded: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/css/screens.scss';

  .language-selector {
    font-size: 23px;
    @media screen and (max-width: $handheld) {
      font-size: 17px;
    }
    ul, li {
      padding: 0;
      top: 0;
      list-style: none;
    }
    li {
      padding-right: 35px;

      @media screen and (max-width: $handheld) {
        padding-right: 23px;
      }
      &:first-child {
        margin-top: 0;
      }
      text-align: right;
      margin-top: 15px;
    }
    .selected {
      display: none;
    }
    .item {
      display: none;
    }
    .current {
      position: relative;
      font-weight: bold;
      &:after {
        background: url('../../assets/arrow-left.png') right center no-repeat;
        background-size: contain;
        content: "";
        position: absolute;
        right: 0;
        top: -3px;
        width: 30px;
        height: 30px;
        transform: rotate(270deg);
        transition: transform 0.2s linear;

        @media screen and (max-width: $handheld) {
          width: 23px;
          height: 23px;
        }
      }
    }
    .expanded {
      li.current:after {
        transform: rotate(90deg);
      }
      .item {
        height: 48px;
        display: block;
      }
      .selected {
        display: none;
      }
    }
  }
</style>
